import { checkTargetAlertNotifications, displayTargetAlert } from '@/utils/helpers'
import { playBuzzer3times } from '@/utils/keyenceHT/buzzer'
import { IBarcode } from 'smartbarcode-web-core/src/utils/types/index'

export async function applyBlockingScanTargetNotificationAlert(
  scannedBarcode: IBarcode,
  setIsDisplayingAlert: (isDisplaying: boolean) => void
): Promise<void> {
  const notificationMessage = await checkTargetAlertNotifications(scannedBarcode)
  if (!notificationMessage) {
    return
  }

  setIsDisplayingAlert(true)
  try {
    playBuzzer3times()
    await displayTargetAlert(scannedBarcode)
  } finally {
    setIsDisplayingAlert(false)
  }
}
